import React, { Fragment } from 'react';
import styles from './UIGameFeedMessage.module.scss';
import { useTranslation, Tooltip } from '@colonist/ui';
// eslint-disable-next-line boundaries/dependencies
import { UIUtilsChat } from '../../../../../../code/client/shared/scripts/ui_chat/UIUtilsChat.ts';
import { Avatar } from '../../../common/Avatar/Avatar.tsx';
import clsx from 'clsx';
import { GameColor } from '../../../utils/GameColor.ts';
import { UIGamePlayerOptionsDropdown } from '../../../common/UIGamePlayerOptionsDropdown/index.ts';
import { CARD_TOOLTIP_LINK_PREFIX } from './FeedMessageDataLogs.ts';
import { CARD_POPUP_BODY } from '@colonist/ui-game';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { useHasOnlyOneHumanPlayer } from '../../../store/selectors/useHasOnlyOneHumanPlayer.ts';
import { usePlayerValidators } from '../../../store/selectors/usePlayerValidators.ts';
import { useRequestPause } from '../../../hooks/usePause.ts';
const replaceDevCardLinksWithTooltipComponent = (str, t)=>{
    const linkRegex = /<a href='(.*)'>(.*)<\/a>/gi;
    const [match] = Array.from(str.matchAll(linkRegex));
    if (match === undefined) return [
        str
    ];
    const [href, text] = match.slice(1);
    const devCardRegex = new RegExp(`${CARD_TOOLTIP_LINK_PREFIX}([0-9]*)`, 'gi');
    const [devCardMatch] = Array.from(href.matchAll(devCardRegex));
    if (devCardMatch === undefined) return [
        str
    ];
    const cardEnum = Number(devCardMatch[1]);
    const popupBody = CARD_POPUP_BODY[cardEnum];
    if (popupBody == undefined) return [
        str
    ];
    const translatedPopupBody = t(popupBody.key, popupBody.options);
    const replacement = /*#__PURE__*/ React.createElement(Tooltip, {
        className: styles.messageWithTooltip,
        content: translatedPopupBody
    }, /*#__PURE__*/ React.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: text
        }
    }));
    const messageWithReplacement = str.replace(linkRegex, '{{replacement}}');
    const messageParts = messageWithReplacement.split(/{{replacement}}/g);
    const messagePartsWithTooltip = [
        ...messageParts[0] != null ? [
            messageParts[0]
        ] : [],
        replacement,
        ...messageParts[1] != null ? [
            messageParts[1]
        ] : []
    ];
    return messagePartsWithTooltip;
};
// TODO: Stop using HTML and convert all the replacement to React components
function formatMessageHTML(message, t, colorAndBoldUsernames) {
    if (colorAndBoldUsernames) message = UIUtilsChat.colorAndBoldUsernames(message);
    message = UIUtilsChat.replaceKeywordsWithImages(message);
    const htmlMessageWithReactComponent = replaceDevCardLinksWithTooltipComponent(message, t);
    return htmlMessageWithReactComponent;
}
export function UIGameFeedMessage({ message, children, opacity, onClick, logIndex }) {
    const { t } = useTranslation();
    const hasOnlyOneHumanPlayer = useHasOnlyOneHumanPlayer();
    const requestPause = useRequestPause();
    const onShowRulebook = useGameStore((state)=>state.gameClientConfig.onShowRulebook);
    const { getPlayerValidator } = usePlayerValidators();
    if (message === undefined) {
        return /*#__PURE__*/ React.createElement("div", {
            className: styles.feedMessage
        }, children);
    }
    const handleClick = (event)=>{
        const target = event.target;
        const link = target.closest('a');
        if (link && link.href) {
            event.preventDefault();
            handleLink(link.href);
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(logIndex !== null && logIndex !== void 0 ? logIndex : 0);
    };
    const handleLink = (href)=>{
        const url = new URL(href);
        if (url.hash === UIUtilsChat.OPEN_RULEBOOK_LINK_HASH) {
            if (hasOnlyOneHumanPlayer) requestPause();
            onShowRulebook();
        }
    };
    const { text, icon, username, usernameColor, colorAndBoldUsernames, italics, isCentered, profilePictureUrl } = message;
    const translated = t(text);
    const messageParts = formatMessageHTML(translated, t, colorAndBoldUsernames);
    const usernameColorHex = usernameColor !== undefined ? GameColor.getPlayerBGDarkHash(usernameColor) : '#000';
    const renderUsername = ()=>{
        const defaultUsername = /*#__PURE__*/ React.createElement("span", {
            className: styles.username,
            style: {
                color: usernameColorHex
            }
        }, username);
        if (usernameColor == undefined) {
            return defaultUsername;
        }
        const playerValidator = getPlayerValidator(usernameColor);
        return /*#__PURE__*/ React.createElement(UIGamePlayerOptionsDropdown, {
            className: styles.playerDropdown,
            playerValidator: playerValidator
        }, /*#__PURE__*/ React.createElement("span", {
            className: styles.username,
            style: {
                color: usernameColorHex
            }
        }, username, /*#__PURE__*/ React.createElement("span", {
            className: styles.colon
        }, ": ")));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.feedMessage, italics && styles.italics, isCentered && styles.centered),
        onClick: handleClick,
        style: {
            opacity: opacity
        }
    }, (icon != null || profilePictureUrl) && /*#__PURE__*/ React.createElement(Avatar, {
        className: styles.avatar,
        hideBackground: !profilePictureUrl,
        image: icon,
        profilePictureUrl: profilePictureUrl
    }), username !== undefined && /*#__PURE__*/ React.createElement(React.Fragment, null, renderUsername()), messageParts.map((part, index)=>{
        if (typeof part === 'string') {
            return /*#__PURE__*/ React.createElement("span", {
                className: styles.messagePart,
                dangerouslySetInnerHTML: {
                    __html: part
                },
                key: index
            });
        } else {
            return /*#__PURE__*/ React.createElement(Fragment, {
                key: index
            }, part);
        }
    }));
}
